import React from "react";

const FormHistoryWeb = () => {
  return <div>FormHistoryWeb</div>;
};

export default FormHistoryWeb;
